import { withGAPromoClick, WithGAButtonClickProps, withGAClickButton } from '../../../hocs';
import { LinkProps, LinkWithGAPromoClickProps } from '../../link';
import { CategoryCard } from './category-card';

export * from './category-card';
export const CategoryCardWithGAPromoClick = withGAPromoClick<
  HTMLAnchorElement, LinkWithGAPromoClickProps
>(CategoryCard);

export type CategoryCardWithGAClickButtonProps = LinkProps & WithGAButtonClickProps;
export const CategoryCardWithGAClickButton = withGAClickButton<CategoryCardWithGAClickButtonProps>(CategoryCard);
